import AutoFusGroupSvg from 'src/assets/images/auto-fus-group-gray.svg';
import styled from 'styled-components';

export const AutoFusGroupPartner = styled(AutoFusGroupSvg)`
  height: 0.875rem;
  width: 10.125rem;
`;
